import { Html } from "@react-three/drei"
import { useFrame } from "@react-three/fiber"
import { gsap, Power2, SplitText } from 'gsap/all'
import { useEffect, useRef, useState } from "react"
import { steps } from "./settings"
import { Header } from "../Front/Front"
import { SvgButton } from "./SvgButton"
import WindowHandler from "../Utils/WindowHandler"
import { LightSwitch } from "./Hud/LightSwitch"
import { Speaker } from "./Hud/Speaker"
import { Arrow } from "./Hud/Arrow"
import { routeUrl } from "../Utils/pulicUrl"


function MobileStepsScreen({ expStep, callBackFunction }) {

    const mobileScreen = useRef()
    const [currentText, setCurrentText] = useState(0)
    const [showText, setShowText] = useState(false)
    const [showButton, setShowButton] = useState(false)

    useEffect(() => {
        if (expStep > 11) {
            mobileScreen.current.classList.add('is-active')

            let cT = 0
            if (expStep === 12) cT = 1
            if (expStep === 13) cT = 2
            if (expStep === 14) cT = 3
            if (expStep === 15) cT = 4

            if (cT !== 0) document.querySelector('html').classList.add('mobile-end-part') 
            else document.querySelector('html').classList.remove('mobile-end-part')

            setShowText(false)
            setShowButton(false)
            setCurrentText(cT)

            const p = {p:0,e:0}
            gsap.to(p, {p: 1, duration: 1, onComplete: () => {
                    callBackFunction()
                    setShowText(true)
                }
            })
            gsap.to(p, {e: 1, duration: .5, onComplete: () => {
                    setShowButton(true)
                }
            })
        } else {
            const p = {p:0}
            gsap.to(p, {p: 0, duration: 3, onComplete: () => {
                mobileScreen.current.classList.remove('is-active')
            }})
            if (expStep === 11) setCurrentText(0)
        }

    }, [expStep, currentText])

    const goToLink = () => {
        if (expStep === 12) window.location.href = routeUrl('/producto')
        if (expStep === 13) window.location.href = routeUrl('/producto')
        if (expStep === 14) window.location.href = routeUrl('/inversion')
        if (expStep === 15) window.location.href = routeUrl('/inversion')
    }

    return <>
        <div ref={ mobileScreen } className="mobile-steps-screen">
            <div className={ "mss__text" + ((currentText === 1 && showText) ? " is-active" : "") }>
                <h1>SOSTENIBLE Y<br/> RESPONSABLE</h1>
                <p>El pilar donde se sustenta Dianelum. Un diamante ético y comprometido con el futuro medioambiental, social y moral. Sin perder ni una pizca de autenticidad.</p>
            </div>
            <div className={ "mss__text" + ((currentText === 2 && showText) ? " is-active" : "") }>
                <h1>MISMA CALIDAD</h1>
                <p>El mismo ADN que un diamante de mina. Aprobado y certificado por el Instituto Gemológico Internacional (IGI) para ser considerado un diamante 100% auténtico.</p>
            </div>
            <div className={ "mss__text" + ((currentText === 3 && showText) ? " is-active" : "") }>
                <h1>INVERSIÓN GARANTIZADA</h1>
                <p>Una inversión garantizada, respaldada por bancos de diamantes de alta calidad y con una tasa de crecimiento anual de dos dígitos.</p>
            </div>
            <div className={ "mss__text" + ((currentText === 4 && showText) ? " is-active" : "") }>
                <h1>SEGURIDAD BLOCKCHAIN</h1>
                <p>Invierte a través de un token propio con trazabilidad Blockchain. Una STO regulada bajo la LMV y supervisada por una ESI y la CNMV protegiendo a nuestros inversores.</p>
            </div>

            <div className={"mss__button" + ((currentText !== 0) ? " is-active" : "") } onClick={ () => goToLink() }>
                <span className={ ((currentText !== 4 && showButton) ? "is-active" : "") }>SABER MÁS</span>
                <span className={ ((currentText === 4 && showButton) ? "is-active" : "") }>INVIERTE</span>
            </div>
        </div>
    </>
}

const progressSteps = [
    { progress: 0, mark: 0 }, // MINA
    { progress: .075, mark: 0 }, // CHIMENEAS
    { progress: .125, mark: 0 }, // MINERO
    { progress: .175, mark: 0 }, // MINA CIELO ABIERTO
    { progress: .225, mark: 0 }, // BALAS
    { progress: .275, mark: 0 }, // VAGONETA
    { progress: .33, mark: 1 }, // PORTAL
    { progress: .5, mark: 1 }, // FORCEP
    { progress: .67, mark: 2 }, // LOUPE
    { progress: .8, mark: 2 }, // GRAPHS
    { progress: .9, mark: 2 }, // GRAPHS UP
    { progress: 1, mark: 3 }, // END
    { progress: 1, mark: 3 }, // MOBILE ONLY: 1
    { progress: 1, mark: 3 }, // MOBILE ONLY: 2
    { progress: 1, mark: 3 }, // MOBILE ONLY: 3
    { progress: 1, mark: 3 }, // MOBILE ONLY: 4
]

export function Hud({ stepBack, stepForward, changeVolume, experienceState, expStep, expStep_PREV, toggleDianelumnizer, positivePartState, dianelumnizer, callBackFunction, showWarning }) {

    const kmCounter = useRef()
    const markName = useRef()
    const progressIndicator = useRef()
    const [loadInvestButton, setLoadInvestButton] = useState(false)
    const isTouch = WindowHandler().isTouch

    useEffect(() => {
        if (experienceState === 2) {
            document.querySelector('.hud').classList.add("show")
        }
    }, [experienceState])
  
    useEffect(() => {
        gsap.to(progressIndicator.current, {
            height: "calc("+progressSteps[expStep].progress * 100 + "% + 1px)",
            duration: 2,
            delay: 0,
            ease: Power2.easeInOut,
            onComplete: () => {
                if (progressSteps[expStep].mark !== progressSteps[expStep_PREV].mark) {
                        if (kmCounter.current)
                        gsap.to(kmCounter.current, {
                            y: -5,
                            duration: .3,
                            opacity: 0,
                            onComplete: () => {
                                kmCounter.current.innerHTML = steps[progressSteps[expStep].mark].km
                                gsap.fromTo(kmCounter.current, {
                                    y: 5,
                                    opacity: 0
                                }, {
                                    y: 0,
                                    opacity: 1,
                                    duration: .3
                                })
                            }
                        })
                        if (markName.current)
                        gsap.to(markName.current, {
                            y: -5,
                            duration: .3,
                            opacity: 0,
                            onComplete: () => {
                                markName.current.innerHTML = steps[progressSteps[expStep].mark].name
                                gsap.fromTo(markName.current, {
                                    y: 5,
                                    opacity: 0
                                }, {
                                    y: 0,
                                    opacity: 1,
                                    duration: .3
                                })
                            }
                        })
                    document.querySelectorAll('.hud__progress-point').forEach((point) => {
                        if (progressSteps[expStep].mark < point.getAttribute('data-index')) {
                            point.classList.remove('reached')
                        } else {
                            point.classList.add('reached')
                        }
                    })
                }
            }
        })

        if (expStep === 11 && !isTouch) {
            const p = {p: 0}
            gsap.to(p, {p: 1, duration: 4.5, onComplete: () => {
                setLoadInvestButton(true)
            }})
            document.querySelector('html').classList.add('last-step')
        } else if (!isTouch) {
            document.querySelector('html').classList.remove('last-step')
            setLoadInvestButton(false)
        }
        if (expStep === 15 && isTouch) {
            document.querySelector('html').classList.add('last-step')
        } else if (isTouch) {
            document.querySelector('html').classList.remove('last-step')
        }
    }, [expStep])

    const hoverLogo = (bool) => {
        if (bool) {
            document.querySelector('.header__logo').classList.add('is-hovered')
        } else {
            document.querySelector('.header__logo').classList.remove('is-hovered')
        }
    }

    const hoverMenu = (bool) => {
        if (bool) {
            document.querySelector('.header__menu').classList.add('is-hovered')
            document.querySelector('.hud__speaker').classList.add('is-hovered')
        } else {
            document.querySelector('.header__menu').classList.remove('is-hovered')
            document.querySelector('.hud__speaker').classList.remove('is-hovered')
        }
    }

    const hoverRights = (bool) => {
        if (bool) {
            document.querySelector('.hud__rights').classList.add('is-hovered')
        } else {
            document.querySelector('.hud__rights').classList.remove('is-hovered')
        }
    }

    const hoverProgress = (bool) => {
        if (bool) {
            document.querySelector('.hud__progress-info').classList.add('is-hovered')
        } else {
            document.querySelector('.hud__progress-info').classList.remove('is-hovered')
        }
    }

    const hoverLeftArrow = (bool) => {
        if (bool) {
            document.querySelector('.hud-arrow.left').classList.add('is-hovered')
        } else {
            document.querySelector('.hud-arrow.left').classList.remove('is-hovered')
        }
    }
    const hoverRightArrow = (bool) => {
        if (bool) {
            document.querySelector('.hud-arrow.right').classList.add('is-hovered')
        } else {
            document.querySelector('.hud-arrow.right').classList.remove('is-hovered')
        }
    }
    const hoverScroll = (bool) => {
        if (bool) {
            document.querySelector('.hud__scroll').classList.add('is-hovered')
        } else {
            document.querySelector('.hud__scroll').classList.remove('is-hovered')
        }
    }

    const invest = () => {
        window.location.href = routeUrl('/inversion')
    }


    return <>
    
        <Html wrapperClass='hud_wrapper'>


            <div className='hud'>

                <Speaker onClick={ changeVolume } isTouch={ isTouch } />
                { !isTouch && <div className="logo_hover_area" onPointerOver={ () => hoverLogo(true) } onPointerOut={ () => hoverLogo(false) }></div> }

                { !isTouch && <div className="menu_hover_area" onPointerOver={ () => hoverMenu(true) } onPointerLeave={ () => hoverMenu(false) }></div> }

                { !isTouch && <>
                <div className="hud__progress">
                    <div className="progress_hover_area" onPointerOver={ () => hoverProgress(true) } onPointerLeave={ () => hoverProgress(false) }></div>
                    <div className='hud__progress-info'>
                        <p className='hud__km'>Km 0<span className='hud__km-counter' ref={ kmCounter }>0</span></p>
                        <p className='hud__step' ref={ markName }>INVERSIÓN</p>
                    </div>
                    <div className='hud__progress-bar'>
                        <div className='hud__progress-points'>
                            {steps.map((step, i) => (
                                <div className={ 'hud__progress-point ' + 'hud-point-'+i } style={ { top: step.mark * 100 + '%' } } key={ i } data-index={ i }></div>
                            ))}
                        </div>
                        <div className='hud__progress-indicator' ref={ progressIndicator }>
                            <div className='hpi__bg'></div>
                            <div className='hpi__cross'></div>
                            <div className="hpi__cross-point"></div>
                        </div>
                    </div>
                </div> 
                </> }
                

                {/* { !isTouch && <div className="scroll_warning_hover_area" onPointerOver={ () => hoverScroll(true) } onPointerLeave={ () => hoverScroll(false) }></div> }
                { !isTouch && <div className='hud__scroll hide-scroll-warning'>
                    <div className='scroll__text'>SCROLL</div>
                    <svg id="Capa_2" className='scroll__finger' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 43 61"><g id="DEDO"><path d="m42.5,60.5V21.77C42.5,10.02,33.1.5,21.5.5h0C9.9.5.5,10.02.5,21.77v38.73" fill="none" stroke="#1c1e1d" strokeLinecap="round" strokeMiterlimit="10"/><path d="m35.65,30.39v-8.55c0-7.87-6.34-14.26-14.15-14.26h0c-7.82,0-14.15,6.38-14.15,14.26v8.55c0,1.26,1.02,2.29,2.27,2.29h23.76c1.26,0,2.27-1.03,2.27-2.29Z" fill="none" stroke="#1c1e1d" strokeLinecap="round" strokeMiterlimit="10"/></g></svg>
                    <div className='scroll__wheel-lines'>
                        <svg className='scroll__wheel' id="Capa_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 53.85"><g id="FONDOS"><rect x=".5" y=".5" width="22" height="52.85" rx="2.35" ry="2.35" fill="none" stroke="#1c1e1d" strokeLinejoin="round"/></g></svg>
                        <svg className='scroll__lines' id="Capa_2" xmlns="http://www.w3.org/2000/svg" width="15" height="93" viewBox="0 0 15 93"><g id="RUEDA"><line x1=".5" y1="52.25" x2="14.5" y2="52.25" fill="none" stroke="#1c1e1d" strokeLinecap="round" strokeLinejoin="round"/><line x1=".5" y1="46.5" x2="14.5" y2="46.5" fill="none" stroke="#1c1e1d" strokeLinecap="round" strokeLinejoin="round"/><line x1=".5" y1="40.75" x2="14.5" y2="40.75" fill="none" stroke="#1c1e1d" strokeLinecap="round" strokeLinejoin="round"/><line x1=".5" y1="35" x2="14.5" y2="35" fill="none" stroke="#1c1e1d" strokeLinecap="round" strokeLinejoin="round"/><line x1=".5" y1="29.25" x2="14.5" y2="29.25" fill="none" stroke="#1c1e1d" strokeLinecap="round" strokeLinejoin="round"/><line x1=".5" y1="23.5" x2="14.5" y2="23.5" fill="none" stroke="#1c1e1d" strokeLinecap="round" strokeLinejoin="round"/><line x1=".5" y1="17.75" x2="14.5" y2="17.75" fill="none" stroke="#1c1e1d" strokeLinecap="round" strokeLinejoin="round"/><line x1=".5" y1="12" x2="14.5" y2="12" fill="none" stroke="#1c1e1d" strokeLinecap="round" strokeLinejoin="round"/><line x1=".5" y1="6.25" x2="14.5" y2="6.25" fill="none" stroke="#1c1e1d" strokeLinecap="round" strokeLinejoin="round"/><line x1=".5" y1=".5" x2="14.5" y2=".5" fill="none" stroke="#1c1e1d" strokeLinecap="round" strokeLinejoin="round"/><line x1=".5" y1="58" x2="14.5" y2="58" fill="none" stroke="#1c1e1d" strokeLinecap="round" strokeLinejoin="round"/><line x1=".5" y1="63.75" x2="14.5" y2="63.75" fill="none" stroke="#1c1e1d" strokeLinecap="round" strokeLinejoin="round"/><line x1=".5" y1="69.5" x2="14.5" y2="69.5" fill="none" stroke="#1c1e1d" strokeLinecap="round" strokeLinejoin="round"/><line x1=".5" y1="75.25" x2="14.5" y2="75.25" fill="none" stroke="#1c1e1d" strokeLinecap="round" strokeLinejoin="round"/><line x1=".5" y1="81" x2="14.5" y2="81" fill="none" stroke="#1c1e1d" strokeLinecap="round" strokeLinejoin="round"/><line x1=".5" y1="86.75" x2="14.5" y2="86.75" fill="none" stroke="#1c1e1d" strokeLinecap="round" strokeLinejoin="round"/><line x1=".5" y1="92.5" x2="14.5" y2="92.5" fill="none" stroke="#1c1e1d" strokeLinecap="round" strokeLinejoin="round"/></g></svg>
                    </div>
                </div> } */}

                { <div className="mobile-scroll-advice hide-scroll-warning">
                    <svg xmlns="http://www.w3.org/2000/svg" width="65.391" height="65.391" viewBox="0 0 65.391 65.391">
                        <g id="Grupo_7802" data-name="Grupo 7802" transform="translate(-178.111 -637.111)">
                            <rect id="Rectángulo_2731" data-name="Rectángulo 2731" width="46.238" height="46.238" transform="translate(178.111 669.807) rotate(-45)" fill="#9bcaa6" opacity="0.978"/>
                            <g id="Grupo_7801" data-name="Grupo 7801" transform="translate(205.09 657.457)">
                            <path id="Trazado_37925" data-name="Trazado 37925" d="M-19862.479-18763.8l-3.5-3.133-2.244-2.016-5.424,5.139-.687-.727,6.092-5.771.344.307,2.588,2.322,3.5,3.133Z" transform="translate(19873.99 18769.633)" fill="#141515"/>
                            <path id="Trazado_37926" data-name="Trazado 37926" d="M11.511,5.826,5.766.68.344,5.816-.344,5.09,5.747-.68l6.431,5.76Z" transform="translate(11.845 24.56) rotate(180)" fill="#141515"/>
                            <path id="Línea_495" data-name="Línea 495" d="M.5,23.654h-1V0h1Z" transform="translate(5.906 0.12)" fill="#141515"/>
                            </g>
                        </g>
                    </svg> 
                    <p>{ isTouch && 'Desliza' }{ !isTouch && 'Scroll' } hacia arriba <br></br>
                        y abajo para moverte</p>
                </div> }


                <div className='hud__controls'>
                    
                    { !isTouch && <div className="arrow_left_hover_area" onPointerOver={ () => hoverLeftArrow(true) } onPointerLeave={ () => hoverLeftArrow(false) }></div> }
                    <Arrow 
                        onClick={ stepBack }
                        disabled={ expStep === 0 }
                        orientation={ 'left' }
                    />
                    { !isTouch && <div className="arrow_right_hover_area" onPointerOver={ () => hoverRightArrow(true) } onPointerLeave={ () => hoverRightArrow(false) }></div> }
                    <Arrow
                        onClick={ stepForward }
                        disabled={ (isTouch) ? expStep === 15 : expStep === 11 }
                        orientation={ 'right' }
                    />

                    <svg onClick={ showWarning } className="info-icon" xmlns="http://www.w3.org/2000/svg" width="36.807" height="36.807" viewBox="0 0 36.807 36.807">
                        <g id="Grupo_7833" data-name="Grupo 7833" transform="translate(-49 -760)">
                            <path id="Trazado_37881" data-name="Trazado 37881" d="M18.4,0A18.4,18.4,0,1,1,0,18.4,18.4,18.4,0,0,1,18.4,0Z" transform="translate(49 760)" fill="#2F302F"/>
                            <path id="Trazado_37881_-_Contorno" data-name="Trazado 37881 - Contorno" d="M18.4,1A17.4,17.4,0,0,0,6.1,30.709,17.4,17.4,0,1,0,30.709,6.1,17.289,17.289,0,0,0,18.4,1m0-1A18.4,18.4,0,1,1,0,18.4,18.4,18.4,0,0,1,18.4,0Z" transform="translate(49 760)" fill="#9bcaa6"/>
                            <text id="i" transform="translate(62 771.001)" fill="#9bcaa6" fontSize="17" fontFamily="ArialMT, Arial"><tspan x="3.612" y="14">i</tspan></text>
                        </g>
                    </svg>

                    { isTouch && <div className="hud__progress">
                        <div className='hud__progress-bar'>
                            <div className='hud__progress-points'>
                                {steps.map((step, i) => (
                                    <div className={ 'hud__progress-point ' + 'hud-point-'+i } style={ { top: step.mark * 100 + '%' } } key={ i } data-index={ i }></div>
                                ))}
                            </div>
                            <div className='hud__progress-indicator' ref={ progressIndicator }>
                                <div className='hpi__bg'></div>
                                <div className='hpi__cross'></div>
                                <div className="hpi__cross-point"></div>
                            </div>
                        </div>
                    </div> }

                    { isTouch && <LightSwitch onClick={ toggleDianelumnizer } visible={ positivePartState } dianelumnizer={ dianelumnizer } /> }
                    

                    <SvgButton onClick={ invest } text={ 'INVERSIÓN' } x={ -60 } classes={ 'end-button' } ready={ loadInvestButton } />

                </div>

                { !isTouch && <div className="rights_hover_area" onPointerOver={ () => hoverRights(true) } onPointerLeave={ () => hoverRights(false) }></div> }
                <div className='hud__rights'>DIANELUM © ALL RIGHTS RESERVED 2023</div>

                <MobileStepsScreen expStep={ expStep } callBackFunction={ callBackFunction } />

            </div>
        </Html>

    </>
}